// extracted by mini-css-extract-plugin
export default {"fullHeightContainer":"PublicLayout_fullHeightContainer__bzAkk"};